import { recoveryUserCancel } from "@/services";
import HBMessage from "../HBMessage";
import HBInfoDialog from "../HBModal/info";

export function isDestoryingAccount(result) {
  return result?.err === 403 && result?.msg === "用户申请注销中";
}

export function openDestoryAccountInfo(option: { onOk?: () => void } = {}) {
  HBInfoDialog.open({
    withHeadline: true,
    width: 480,
    title: "提示",
    content: `当前账号已提交注销申请，当前系统正在核查数据处理注销中。
若要恢复使用账号，请点击「恢复使用」，即可撒销账号注销申请，正常使用账号。`,
    okText: "恢复使用",
    cancelText: "取消",
    async onOk() {
      await recoveryUserCancel();
      HBMessage.success("操作成功，请重新登录");
      option?.onOk?.();
    },
    maskClosable: false,
    closable: false,
    okButtonProps: {
      style: {
        width: 88,
      },
    },
    cancelButtonProps: {
      style: {
        width: 88,
      },
    },
  });
}
